import PositionGroup from "../positionGroup/positionGroup";
import "./listSelectsPlayers.sass";

export default function ListSelectsPlayers({ POSITIONS, selectedPlayers, removePlayer, accentColor, accentColorAlt }) {
  return (
    <div className="lsp-groups">
      {POSITIONS.map((pos, posIndex) => (
        <PositionGroup
          {...{ pos, removePlayer, accentColor, accentColorAlt, posIndex }}
          key={pos}
          players={selectedPlayers.filter((p) => p.posicion === pos)}
        />
      ))}
    </div>
  );
}